<template>
  <el-table-column
    prop="created_at"
    sortable="custom"
    label="Kihelyezés időpontja"
    show-overflow-tooltip
    min-width="250"
  >
    <template slot-scope="scope">
      <el-tag v-if="getPlacementTime(scope.row.created_at).unitOfTime === 'órája' || getPlacementTime(scope.row.created_at).unitOfTime === 'napja' && getPlacementTime(scope.row.created_at).duration < 10" size="small" type="success"> {{ getPlacementTime(scope.row.created_at).duration }} {{ getPlacementTime(scope.row.created_at).unitOfTime }} </el-tag>
      <el-tag v-if="getPlacementTime(scope.row.created_at).unitOfTime === 'napja' && getPlacementTime(scope.row.created_at).duration < 30 && getPlacementTime(scope.row.created_at).duration >= 10" size="small" type="warning"> {{ getPlacementTime(scope.row.created_at).duration }} {{ getPlacementTime(scope.row.created_at).unitOfTime }} </el-tag>
      <el-tag v-if="getPlacementTime(scope.row.created_at).unitOfTime === 'napja' && getPlacementTime(scope.row.created_at).duration >= 30" size="small" type="danger"> {{ getPlacementTime(scope.row.created_at).duration }} {{ getPlacementTime(scope.row.created_at).unitOfTime }} </el-tag>
      <div style="margin-top: 5px">{{ scope.row.created_at | dateTime }}</div>
    </template>
  </el-table-column>
</template>

<script>
  import moment from 'moment';
  export default {
    propName: 'created_at',
    methods: {
      getPlacementTime(placementDate) {
        let placementTime = {
          unitOfTime: 'napja',
          duration: moment().diff(moment(placementDate), 'days')
        };
        if(placementTime.duration === 0) {
          placementTime.unitOfTime = 'órája';
          placementTime.duration = moment().diff(moment(placementDate), 'hours')
        }
        return placementTime;
      }
    }
  };
</script>
